import React, { useEffect, useMemo, useState } from 'react'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { getFormOfEducation, deleteFormOfEducation } from '../../actions/directory'

export default function FormsOfEducation() {
  const dispatch = useDispatch()
  const { formOfEducation } = useSelector(state => state.directory)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false)
  const [sortAsc, setSortAsc] = useState(true)

  useEffect(() => {
    dispatch(getFormOfEducation())
  }, [])

  const sortedList = useMemo(() => {
    if (!formOfEducation) return []
    return [...formOfEducation].sort((a, b) => sortAsc
      ? a.name?.localeCompare(b.name, 'ru')
      : b.name?.localeCompare(a.name, 'ru'))
  }, [formOfEducation, sortAsc])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const acceptConfirmation = () => {
    closeModal()
    dispatch(deleteFormOfEducation(confirmation.id))
    setConfirmation(false)
  }
  const rejectConfirmation = () => {
    setConfirmation(false)
  }

  const renderLi = (data) => {
    const { f_studyform, name } = data
    return (
      <tr key={f_studyform} onClick={openModal(data)}>
        <td>{name}</td>
        <td>
          <button
            type="button"
            className={styles.deleteBtn}
            onClick={(e) => { e.stopPropagation(); setConfirmation({ id: f_studyform, name }) }}
            title="Удалить запись"
            aria-label="Удалить"
          >
            <BiTrash size={20} />
          </button>
        </td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить "${confirmation.name}"?`}
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
        />
      }
      <header className={styles.header}>
        <h1>Формы обучения</h1>
      </header>
      <main className={styles.content}>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th onClick={() => setSortAsc(v => !v)} style={{ cursor: 'pointer' }}>Название</th>
              <th style={{ width: '70px' }}>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {sortedList.map(renderLi)}
          </tbody>
        </Table>
        <div className={styles.actions}>
          <Button style={{ padding: '.5rem 1.5rem' }} onClick={openModal()}>
            <IoIosAdd size={30} />
            Добавить
          </Button>
          <span className={styles.counter}>Всего записей: {sortedList.length}</span>
        </div>
      </main>
    </div>
  )
}
